import React, { useState, useRef, useEffect } from "react";
import { getLanguage } from 'react-switch-lang';
import en from './en.json';
import ma from './ma.json';
import "./About_manashakti.css";
import VideoTestimonialCard from "./components/eventCards/VideoTestimonialCard";
import iconBrain from "./assets/home_icons/Home Page_website-03.png";
import iconEye from "./assets/home_icons/Home Page_website-04.png";
import iconBook from "./assets/home_icons/Home Page_website-05.png";
import iconGroup from "./assets/home_icons/Home Page_website-06.png";

const translationData = { en: en, mr: ma };

const About_manashakti = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((s) => !s);
  const downloadRef = useRef(null);
  const [showVideoModal, setShowVideoModal] = useState(false);
  
  // Use local PDF files for direct download
  const englishLink = '/English_Information_Booklet.pdf';
  const marathiLink = '/Marathi_Information_Booklet.pdf';
  // Use Hindi PDF for Hindi download
  const hindiLink = '/Hindi_Information_Booklet.pdf';
  const [lang, setLang] = useState(() => getLanguage() || 'en');

  const t = (key) => {
    const langKey = lang === 'ma' || lang === 'mr' ? 'mr' : 'en';
    return translationData[langKey]?.[key] || '';
  };

  useEffect(() => {
    const checkLang = () => {
      const current = getLanguage() || 'en';
      setLang(prev => prev !== current ? current : prev);
    };
    checkLang();
    const interval = setInterval(checkLang, 500);
    window.addEventListener('storage', checkLang);
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', checkLang);
    };
  }, []);

  const marathiVideo = "https://www.youtube.com/embed/WfU5jaxulH8?autoplay=1";
  const englishVideo = "https://www.youtube.com/embed/h0oNjdKIJzk?autoplay=1";
  const videoEmbedUrl = (lang === "ma" || lang === "mr") ? marathiVideo : englishVideo;

  const marathiThumbnail = "https://img.youtube.com/vi/WfU5jaxulH8/maxresdefault.jpg";
  const englishThumbnail = "https://img.youtube.com/vi/h0oNjdKIJzk/maxresdefault.jpg";
  const videoThumbnail = (lang === "ma" || lang === "mr") ? marathiThumbnail : englishThumbnail;

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (downloadRef.current && !downloadRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  return (
    <div className="about-container container mt-4">
      <div className="about-row">
        <div className="about-left">
          {/* ✅ Small Card Only Around Video + Caption */}
          <div className="video-card-container">
            <VideoTestimonialCard
              thumbnail={videoThumbnail}
              title={t('about_watch_video')}
              onPlay={() => setShowVideoModal(true)}
              className="about-video-card"
            />
          </div>

        </div>

        <div className="about-right">
          <div className="eyebrow">{t('about_eyebrow')}</div>
          <h2 className="about-title">
            {t('about_title')}
          </h2>

          <div className="features">
            <ul className="feature-col">
              <li>
                <img src={iconBrain} alt="" className="feature-icon" />
                {t('about_feature1')}
              </li>
              <li>
                <img src={iconEye} alt="" className="feature-icon" />
                {t('about_feature2')}
              </li>
            </ul>

            <ul className="feature-col">
              <li>
                <img src={iconBook} alt="" className="feature-icon" />
                {t('about_feature3')}
              </li>
              <li>
                <img src={iconGroup} alt="" className="feature-icon" />
                {t('about_feature4')}
              </li>
            </ul>
          </div>

          <div className="download-area" ref={downloadRef}>
            <button
              className="download-btn"
              onClick={toggle}
              aria-expanded={open}
            >
              {t('about_download')}
            </button>

            {open && (
              <div className="download-dropdown" role="menu">
                {/* English download */}
                <a
                  href={englishLink}
                  className="download-item"
                  download
                >
                  {t('download_lang_english')}
                </a>

                {/* Hindi download */}
                <a
                  href={hindiLink}
                  className="download-item"
                  download
                >
                  {t('download_lang_hindi')}
                </a>

                {/* Marathi download */}
                <a
                  href={marathiLink}
                  className="download-item"
                  download
                >
                  {t('download_lang_marathi')}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
      {showVideoModal && (
        <div
          className="video-modal-overlay"
          onClick={() => setShowVideoModal(false)}
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            className="video-modal"
            role="dialog"
            aria-modal="true"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '90%',
              maxWidth: 960,
              background: '#000',
              borderRadius: 8,
              padding: 0,
              overflow: 'hidden',
            }}
          >
            <button
              onClick={() => setShowVideoModal(false)}
              aria-label="Close video"
              style={{
                position: 'absolute',
                right: 12,
                top: 12,
                zIndex: 10000,
                background: 'transparent',
                color: '#fff',
                border: 'none',
                fontSize: 28,
                cursor: 'pointer',
              }}
            >
              ×
            </button>
            <div style={{ position: 'relative', paddingTop: '56.25%' }}>
              <iframe
                src={videoEmbedUrl}
                title="Introduction Video"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default About_manashakti;